import { render, staticRenderFns } from "./PageBus.vue?vue&type=template&id=e03d000a&scoped=true&"
import script from "./PageBus.vue?vue&type=script&lang=js&"
export * from "./PageBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03d000a",
  null
  
)

export default component.exports